/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  JobEntryDTO,
  JobEntryFiltersDTO,
  JobFiltersDTO,
  PageJobDTO,
  PageJobEntryDTO,
} from '../models/index';
import {
    JobEntryDTOFromJSON,
    JobEntryDTOToJSON,
    JobEntryFiltersDTOFromJSON,
    JobEntryFiltersDTOToJSON,
    JobFiltersDTOFromJSON,
    JobFiltersDTOToJSON,
    PageJobDTOFromJSON,
    PageJobDTOToJSON,
    PageJobEntryDTOFromJSON,
    PageJobEntryDTOToJSON,
} from '../models/index';

export interface GetJobEntriesRequest {
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
    statusType?: GetJobEntriesStatusTypeEnum;
    isDuplicate?: boolean;
    jobId?: number;
    searchParameter?: string;
}

export interface GetJobsRequest {
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
    processType?: GetJobsProcessTypeEnum;
    tenant?: GetJobsTenantEnum;
    jobType?: GetJobsJobTypeEnum;
}

export interface ReimportJobEntriesRequest {
    requestBody: Array<number>;
}

/**
 * 
 */
export class ImportManagementServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getJobEntries without sending the request
     */
    async getJobEntriesRequestOpts(requestParameters: GetJobEntriesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['statusType'] != null) {
            queryParameters['statusType'] = requestParameters['statusType'];
        }

        if (requestParameters['isDuplicate'] != null) {
            queryParameters['isDuplicate'] = requestParameters['isDuplicate'];
        }

        if (requestParameters['jobId'] != null) {
            queryParameters['jobId'] = requestParameters['jobId'];
        }

        if (requestParameters['searchParameter'] != null) {
            queryParameters['searchParameter'] = requestParameters['searchParameter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/management/entries`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getJobEntriesRaw(requestParameters: GetJobEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageJobEntryDTO>> {
        const requestOptions = await this.getJobEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageJobEntryDTOFromJSON(jsonValue));
    }

    /**
     */
    async getJobEntries(requestParameters: GetJobEntriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageJobEntryDTO> {
        const response = await this.getJobEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getJobEntriesFilters without sending the request
     */
    async getJobEntriesFiltersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/management/entries/filters`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getJobEntriesFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobEntryFiltersDTO>> {
        const requestOptions = await this.getJobEntriesFiltersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobEntryFiltersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getJobEntriesFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobEntryFiltersDTO> {
        const response = await this.getJobEntriesFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getJobs without sending the request
     */
    async getJobsRequestOpts(requestParameters: GetJobsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['processType'] != null) {
            queryParameters['processType'] = requestParameters['processType'];
        }

        if (requestParameters['tenant'] != null) {
            queryParameters['tenant'] = requestParameters['tenant'];
        }

        if (requestParameters['jobType'] != null) {
            queryParameters['jobType'] = requestParameters['jobType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/management/jobs`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getJobsRaw(requestParameters: GetJobsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageJobDTO>> {
        const requestOptions = await this.getJobsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageJobDTOFromJSON(jsonValue));
    }

    /**
     */
    async getJobs(requestParameters: GetJobsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageJobDTO> {
        const response = await this.getJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getJobsFilters without sending the request
     */
    async getJobsFiltersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/management/jobs/filters`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getJobsFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobFiltersDTO>> {
        const requestOptions = await this.getJobsFiltersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFiltersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getJobsFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobFiltersDTO> {
        const response = await this.getJobsFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reimportJobEntries without sending the request
     */
    async reimportJobEntriesRequestOpts(requestParameters: ReimportJobEntriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling reimportJobEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/management/reimport`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async reimportJobEntriesRaw(requestParameters: ReimportJobEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JobEntryDTO>>> {
        const requestOptions = await this.reimportJobEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JobEntryDTOFromJSON));
    }

    /**
     */
    async reimportJobEntries(requestParameters: ReimportJobEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JobEntryDTO>> {
        const response = await this.reimportJobEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetJobEntriesStatusTypeEnum = {
    Error: 'ERROR',
    SuccessWithError: 'SUCCESS_WITH_ERROR',
    Success: 'SUCCESS',
    Initial: 'INITIAL'
} as const;
export type GetJobEntriesStatusTypeEnum = typeof GetJobEntriesStatusTypeEnum[keyof typeof GetJobEntriesStatusTypeEnum];
/**
 * @export
 */
export const GetJobsProcessTypeEnum = {
    Scopus: 'scopus',
    Wos: 'wos',
    Cr: 'cr',
    External: 'external',
    Dc: 'dc',
    Gvi: 'gvi',
    Enrich: 'enrich',
    Openalex: 'openalex',
    PersonLinking: 'personLinking'
} as const;
export type GetJobsProcessTypeEnum = typeof GetJobsProcessTypeEnum[keyof typeof GetJobsProcessTypeEnum];
/**
 * @export
 */
export const GetJobsTenantEnum = {
    Rub: 'RUB',
    Uwh: 'UWH',
    Hhu: 'HHU',
    Tudo: 'TUDO',
    Common: 'COMMON',
    Other: 'OTHER'
} as const;
export type GetJobsTenantEnum = typeof GetJobsTenantEnum[keyof typeof GetJobsTenantEnum];
/**
 * @export
 */
export const GetJobsJobTypeEnum = {
    Delta: 'delta',
    Ids: 'ids',
    Enrich: 'enrich',
    Noinfo: 'noinfo',
    PersonLinking: 'personLinking'
} as const;
export type GetJobsJobTypeEnum = typeof GetJobsJobTypeEnum[keyof typeof GetJobsJobTypeEnum];
